import script from "./AddUserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserModal.vue?vue&type=script&setup=true&lang=js"

import "./AddUserModal.vue?vue&type=style&index=0&id=dda8d8f6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dda8d8f6"]])

export default __exports__